var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import eventBus from '../../utils/fresh-table';
import { exportData } from '../../utils/common-export-polling';
import colorSelect from './color-select.vue';
import searchInput from '../../components/console-common/search-input.vue';
export default Vue.extend({
    components: {
        'el-select-color': colorSelect,
        'el-search-input': searchInput,
    },
    created: function () {
        var _a = this, searchForm = _a.searchForm, defaultSearch = _a.defaultSearch, preFilledParam = _a.preFilledParam;
        this.searchForm = Object.assign({}, searchForm, defaultSearch, preFilledParam); // 赋初始值 比如radio有默认选中项
    },
    computed: {
        maxHeight: function () {
            return window.innerHeight - 164;
        },
        foldingTxt: function () {
            return this.foldingStatus ? '收起筛选条件' : '展开更多筛选条件';
        },
        isUseFolding: function () {
            return this.searchConfig.length > 9;
        },
        normalHeight: function () {
            var defaultHeight = '168px';
            if (this.searchConfig) {
                defaultHeight = Math.ceil(this.searchConfig.length / 3) * 56 + "px";
            }
            return defaultHeight;
        },
    },
    data: function () {
        return {
            foldingStatus: false,
            searchForm: {},
            searchParams: {},
            resultList: [],
            pageNo: 1,
            pageSize: 20,
            totalItemCount: 30,
            isPagination: true,
            pickerOptions: {},
            sortParams: {
                order: '',
            },
        };
    },
    props: {
        tableTitle: {
            type: String,
            default: function () {
                return '';
            },
        },
        isMountedQuery: {
            type: Boolean,
            default: true,
        },
        // tableDateConfig: {
        //   type: Object,
        //   default() {
        //     return {}
        //   },
        // },
        preFilledParam: {
            type: Object,
            default: function () {
                return {};
            },
        },
        otherParam: {
            type: Object,
            default: function () {
                return {};
            },
        },
        isClearOtherParam: {
            type: Boolean,
            default: false,
        },
        defaultSearch: {
            type: Object,
            default: function () {
                return {};
            },
        },
        searchConfig: {
            type: Array,
            default: function () {
                return [];
            },
        },
        tableConfig: {
            type: Array,
            default: function () {
                return [];
            },
        },
        otherConfig: {
            type: Object,
            default: function () {
                return {};
            },
        },
        requestConfig: {
            type: Object,
        },
        exportConfig: {
            type: Object,
            default: function () {
                return {};
            },
        },
        spanConfigCallback: {
            type: Function,
            default: function () {
                return null;
            },
        },
        isShowTableNav: {
            type: Boolean,
            default: true,
        },
        cellConfig: {
            type: Object,
            default: function () {
                return {};
            },
        },
        border: {
            type: Boolean,
            default: function () {
                return false;
            },
        },
        // 筛选条件发生变化触发
        filterChange: {
            type: Function,
            default: function () {
                return function () { };
            },
        },
    },
    mounted: function () {
        var isPagination = this.otherConfig.isPagination;
        if (isPagination !== undefined) {
            this.isPagination = isPagination;
        }
        eventBus.$on('freshTable', this.filter);
        if (this.isMountedQuery) {
            this.filter();
        }
    },
    methods: {
        switchFoldingStatus: function () {
            this.foldingStatus = !this.foldingStatus;
        },
        clearDate: function () {
            var _this = this;
            this.searchConfig.forEach(function (item) {
                if (item.type === 'selectDate') {
                    var val = _this.searchForm[item.dateKey];
                    if (typeof val === 'object' && val instanceof Array) {
                        _this.searchForm[item.dateKey] = [];
                    }
                }
            });
        },
        reset: function () {
            this.pageNo = 1;
            this.pageSize = 20;
            this.searchForm = Object.assign({}, this.defaultSearch);
            this.filter();
        },
        sortQuery: function (_a) {
            var column = _a.column, prop = _a.prop, order = _a.order;
            var orderVal = '';
            var sortableUp = '';
            var sortableDown = '';
            column &&
                this.tableConfig.forEach(function (item) {
                    if (item.prop === prop) {
                        sortableUp = item.sortableUp;
                        sortableDown = item.sortableDown;
                    }
                });
            if (order === 'ascending') {
                orderVal = sortableUp;
            }
            if (order === 'descending') {
                orderVal = sortableDown;
            }
            this.sortParams = Object.assign(this.sortParams, {
                order: orderVal,
            });
            this.filter();
        },
        getParams: function () {
            var _a = this, otherParam = _a.otherParam, searchForm = _a.searchForm, sortParams = _a.sortParams;
            var param = searchForm; // 默认提取查询模块的查询条件
            var params = __assign({ pageNo: this.pageNo, pageSize: this.pageSize }, param, otherParam, sortParams);
            var formatDate = function (date) {
                return date ? moment(date).format('YYYY-MM-DD') : '';
            };
            this.searchConfig.forEach(function (item) {
                if (item.type === 'inputSearch') {
                    params[params[item.key]] = params[item.key + "_input"] || '';
                    delete params[item.key];
                    delete params[item.key + "_input"];
                }
                if (item.type === 'dateRange') {
                    var start = params[item.startTimeKey];
                    var end = params[item.endTimeKey];
                    params[item.startTimeKey] = formatDate(start);
                    params[item.endTimeKey] = formatDate(end);
                }
                if (item.type === 'date') {
                    var dateTxt = params[item.date];
                    params[item.date] = formatDate(dateTxt);
                }
                if (item.type === 'selectDate') {
                    var dateType = params.dateType;
                    var selectDate = params[item.dateKey];
                    if (selectDate &&
                        typeof selectDate === 'object' &&
                        selectDate.length > 0) {
                        var _a = item['dateTypes'][dateType], start = _a[0], end = _a[1];
                        params[start] = formatDate(selectDate[0]);
                        params[end] = formatDate(selectDate[1]);
                    }
                    delete params[item.dateKey];
                    delete params.dateType;
                }
            });
            this.searchParams = params;
            return params;
        },
        filterBefore: function () {
            this.pageNo = 1;
            this.pageSize = 20;
            this.filter();
        },
        filter: function () {
            var _this = this;
            var params = this.getParams(); // 获得查询参数
            var _a = this.requestConfig, url = _a.url, method = _a.method;
            this.$request({
                url: url,
                method: method,
                data: params,
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode) {
                    return;
                }
                var pageNo = res.pageNo, pageSize = res.pageSize, totalItemCount = res.totalItemCount, data = res.data;
                _this.pageNo = pageNo;
                _this.pageSize = pageSize;
                _this.totalItemCount = totalItemCount;
                _this.resultList = data;
            });
        },
        sizeChange: function (val) {
            this.pageSize = val;
            this.filter();
        },
        currentChange: function (val) {
            this.pageNo = val;
            this.filter();
        },
        exportMain: function () {
            var _a = this.exportConfig, keyUrl = _a.keyUrl, keyMethod = _a.keyMethod, statusUrl = _a.statusUrl, statusMethod = _a.statusMethod;
            var params = this.getParams();
            delete params.pageNo;
            delete params.pageSize;
            exportData({
                keyUrl: keyUrl,
                keyMethod: keyMethod,
                statusUrl: statusUrl,
                statusMethod: statusMethod,
                params: params,
            });
        },
        cellStyle: function (_a) {
            var row = _a.row, column = _a.column;
            var cellConfig = this.cellConfig;
            var keys = typeof cellConfig && cellConfig !== null ? Object.keys(cellConfig) : [];
            var styles = '';
            if (keys.length > 0) {
                keys.forEach(function (item) {
                    if (column.property === item) {
                        cellConfig[item].forEach(function (eItem) {
                            var status = eItem.status, style = eItem.style, flag = eItem.flag;
                            if (!flag) {
                                if (row[item] === status) {
                                    styles = style;
                                }
                            }
                            else {
                                row[flag] === status ? (styles = style) : '';
                            }
                        });
                    }
                });
            }
            return styles;
        },
        btnOpe: function (callback, row) {
            callback && typeof callback === 'function' && callback(row);
        },
    },
    watch: {
        otherParam: function () {
            // update list
            if (this.isClearOtherParam) {
                this.pageNo = 1;
                this.pageSize = 20;
            }
            this.filter();
        },
    },
});
